// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CompaniesListDto } from '../models';
// @ts-ignore
import type { VacancyCompaniesListDto } from '../models';
// @ts-ignore
import type { VacancyCompaniesRequestDto } from '../models';
/**
 * VacancyCompaniesApi - axios parameter creator
 */
export const VacancyCompaniesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Companies dictionary list
         * @param {VacancyCompaniesRequestDto} vacancyCompaniesRequestDto Find companies request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesList: async (vacancyCompaniesRequestDto: VacancyCompaniesRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vacancyCompaniesRequestDto' is not null or undefined
            assertParamExists('getCompaniesList', 'vacancyCompaniesRequestDto', vacancyCompaniesRequestDto)
            const localVarPath = `/api/v1/companies/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vacancyCompaniesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VacancyCompaniesRequestDto} vacancyCompaniesRequestDto 
         * @param {string} [vacancyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesListForVacancy: async (vacancyCompaniesRequestDto: VacancyCompaniesRequestDto, vacancyId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vacancyCompaniesRequestDto' is not null or undefined
            assertParamExists('getCompaniesListForVacancy', 'vacancyCompaniesRequestDto', vacancyCompaniesRequestDto)
            const localVarPath = `/api/v1/vacancy/companies/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vacancyId !== undefined) {
                localVarQueryParameter['vacancyId'] = vacancyId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vacancyCompaniesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VacancyCompaniesApi - functional programming interface
 */
export const VacancyCompaniesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VacancyCompaniesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Companies dictionary list
         * @param {VacancyCompaniesRequestDto} vacancyCompaniesRequestDto Find companies request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompaniesList(vacancyCompaniesRequestDto: VacancyCompaniesRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompaniesListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompaniesList(vacancyCompaniesRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VacancyCompaniesApi.getCompaniesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VacancyCompaniesRequestDto} vacancyCompaniesRequestDto 
         * @param {string} [vacancyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompaniesListForVacancy(vacancyCompaniesRequestDto: VacancyCompaniesRequestDto, vacancyId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VacancyCompaniesListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompaniesListForVacancy(vacancyCompaniesRequestDto, vacancyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VacancyCompaniesApi.getCompaniesListForVacancy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VacancyCompaniesApi - factory interface
 */
export const VacancyCompaniesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VacancyCompaniesApiFp(configuration)
    return {
        /**
         * 
         * @summary Companies dictionary list
         * @param {VacancyCompaniesRequestDto} vacancyCompaniesRequestDto Find companies request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesList(vacancyCompaniesRequestDto: VacancyCompaniesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CompaniesListDto> {
            return localVarFp.getCompaniesList(vacancyCompaniesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VacancyCompaniesRequestDto} vacancyCompaniesRequestDto 
         * @param {string} [vacancyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesListForVacancy(vacancyCompaniesRequestDto: VacancyCompaniesRequestDto, vacancyId?: string, options?: RawAxiosRequestConfig): AxiosPromise<VacancyCompaniesListDto> {
            return localVarFp.getCompaniesListForVacancy(vacancyCompaniesRequestDto, vacancyId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VacancyCompaniesApi - interface
 */
export interface VacancyCompaniesApiInterface {
    /**
     * 
     * @summary Companies dictionary list
     * @param {VacancyCompaniesRequestDto} vacancyCompaniesRequestDto Find companies request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompaniesList(vacancyCompaniesRequestDto: VacancyCompaniesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CompaniesListDto>;

    /**
     * 
     * @param {VacancyCompaniesRequestDto} vacancyCompaniesRequestDto 
     * @param {string} [vacancyId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompaniesListForVacancy(vacancyCompaniesRequestDto: VacancyCompaniesRequestDto, vacancyId?: string, options?: RawAxiosRequestConfig): AxiosPromise<VacancyCompaniesListDto>;

}

/**
 * VacancyCompaniesApi - object-oriented interface
 */
export class VacancyCompaniesApi extends BaseAPI implements VacancyCompaniesApiInterface {
    /**
     * 
     * @summary Companies dictionary list
     * @param {VacancyCompaniesRequestDto} vacancyCompaniesRequestDto Find companies request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCompaniesList(vacancyCompaniesRequestDto: VacancyCompaniesRequestDto, options?: RawAxiosRequestConfig) {
        return VacancyCompaniesApiFp(this.configuration).getCompaniesList(vacancyCompaniesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VacancyCompaniesRequestDto} vacancyCompaniesRequestDto 
     * @param {string} [vacancyId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCompaniesListForVacancy(vacancyCompaniesRequestDto: VacancyCompaniesRequestDto, vacancyId?: string, options?: RawAxiosRequestConfig) {
        return VacancyCompaniesApiFp(this.configuration).getCompaniesListForVacancy(vacancyCompaniesRequestDto, vacancyId, options).then((request) => request(this.axios, this.basePath));
    }
}

